export default "__VITE_ASSET__B$6Ewp$H__"